import { useStrictInstance } from '@funtech-int/rival-react';

import { backendClientRef } from '@/shared/lib/backendClient';

export function useBackendClient() {
    return useStrictInstance(backendClientRef);
}
